/** @jsxImportSource theme-ui */
import { graphql } from 'gatsby'
import { jsx } from "theme-ui"
import React from 'react'
import { Box, Flex, Heading, Text } from '@theme-ui/components'
import { Layout, SEO } from '../../components'
import { Container } from "../../components/organisms"

import StackedLayout from '../../garden/components/stacked-layout'
import Header from '../../garden/components/header'
import { PageHeading } from '../../components/molecules'
import MDXRenderer from '../../garden/components/mdx-components/mdx-renderer'

const GardenWikiPage = ({data, location}) => {
  const hrefLang = "en-us";
  const title = data.file.childMdx.frontmatter?.seoTitle || data.file.childMdx.fields.title;
  const pathname = data.file.childMdx.fields.slug;
  const description = data.file.childMdx.frontmatter?.seoDescription;

  return (
    <Box className='garden-wrapper'>
      <SEO  title={title} desc={description} pathname={pathname} article hrefLang={hrefLang} />
      <Header />
      <Box sx={{pt: '0', border: '0px solid red'}}>
        <StackedLayout location={location} data={data}/>
      </Box>
    </Box>
  )
}

export default GardenWikiPage;

export const gardenPageData = graphql`
  query($id: String!) {
    file(id: {eq: $id}) {
      id
      childMdx {
        fields {
          slug
          title
        }
        frontmatter {
          seoTitle
          seoDescription
          title
        }
        body
        ...GatsbyGardenReferences
      }
    }
  }
`;
